module.exports = __webpack_public_path__ + "img/communicate-by-channel.16f7a43b.svg";